module.exports = __webpack_public_path__ + "img/search.2dec76a4.svg";